// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__KQqwr","list_item":"styles_list_item__NtMeI","more":"styles_more__o7SEE"};